import {
    API_GET_ALL_PROVIDER
} from "actions/provider";


export function getAllProviders() {
    return {
        type: API_GET_ALL_PROVIDER,
        payload: {
            request: {
                url: `/providers`
            }
        }
    };
}
